import { render, staticRenderFns } from "./TabelaPercentual.vue?vue&type=template&id=6b78ad5b&scoped=true"
import script from "./TabelaPercentual.vue?vue&type=script&lang=js"
export * from "./TabelaPercentual.vue?vue&type=script&lang=js"
import style0 from "./TabelaPercentual.vue?vue&type=style&index=0&id=6b78ad5b&prod&lang=css"
import style1 from "./TabelaPercentual.vue?vue&type=style&index=1&id=6b78ad5b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b78ad5b",
  null
  
)

export default component.exports